// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"251":"eab6b86a","453":"258b012d","768":"1725b434"}[chunkId] + ".chunk.js";
};